import React, { useState } from 'react';
import './Education.css';
import ResultSSC from '../../assets/DHARMENDRA PRAJAPATI - SSC.pdf';
import ResultHSC from '../../assets/DHARMENDRA PRAJAPATI - HSC.pdf';
import Result5 from '../../assets/DHARMENDRA PRAJAPATI - 5th.pdf';

const Education = () => {

    const [toggleState, setToggleState] = useState(-1);

    const toggleTab = (index) => {
        setToggleState(index);
    }

    return (
        <div className="education education__section" id='education'>
            <h2 className="section__title">Education</h2>

            <div className="education__container container">
                <div className="education__tab">
                    <i className="uil uil-graduation-cap education__icon"></i>
                    Education
                </div>

                <div className="education__part">
                    <div className="education__content">


                        <div className="education__data">
                            <div className="education__subdata">
                                <div>
                                    <h3 className="education__title education__title-flex">B.Tech - IT</h3>
                                </div>

                                <span className="education__button education__button-flex" onClick={() => toggleTab(1)}>
                                    View More
                                    <i className="uil uil-arrow-right education__button-icon"></i>
                                </span>
                            </div>

                            <div className={toggleState === 1 ? "education__modal active-modal" : "education__modal"}>
                                <div className="education__modal-content">
                                    <i className="uil uil-times education__modal-close" onClick={() => toggleTab(0)}></i>

                                    <h3 className="education__modal-title"> B.Tech - Information Technology</h3>

                                    <div className="education__modal-description">
                                        <div className="education__subtitle">
                                            <i class="uil uil-check-circle"></i>
                                            Chandubhai S Patel Institute of Technology</div>
                                        <div className="education__subtitle">
                                            <i class="uil uil-check-circle"></i>
                                            Changa, Anand, Gujarat </div>
                                        <div class="education__grade">
                                            <i class="uil uil-check-circle"></i>
                                            CGPA: 8.87</div>
                                        <div className="education__calender">
                                            <i class="uil uil-calendar-alt"></i>
                                            2020 - Present
                                        </div>
                                    </div>

                                    <a download="" href={Result5} className="download button button--flex">
                                        Download

                                        <svg
                                            className="button__icon"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                d="M15.25 22.7502H9.25C3.82 22.7502 1.5 20.4302 1.5 15.0002V9.00024C1.5 3.57024 3.82 1.25024 9.25 1.25024H14.25C14.66 1.25024 15 1.59024 15 2.00024C15 2.41024 14.66 2.75024 14.25 2.75024H9.25C4.64 2.75024 3 4.39024 3 9.00024V15.0002C3 19.6102 4.64 21.2502 9.25 21.2502H15.25C19.86 21.2502 21.5 19.6102 21.5 15.0002V10.0002C21.5 9.59024 21.84 9.25024 22.25 9.25024C22.66 9.25024 23 9.59024 23 10.0002V15.0002C23 20.4302 20.68 22.7502 15.25 22.7502Z"
                                                fill="var(--container-color)"
                                            ></path>
                                            <path
                                                d="M22.25 10.7502H18.25C14.83 10.7502 13.5 9.42023 13.5 6.00023V2.00023C13.5 1.70023 13.68 1.42023 13.96 1.31023C14.24 1.19023 14.56 1.26023 14.78 1.47023L22.78 9.47023C22.99 9.68023 23.06 10.0102 22.94 10.2902C22.82 10.5702 22.55 10.7502 22.25 10.7502ZM15 3.81023V6.00023C15 8.58023 15.67 9.25023 18.25 9.25023H20.44L15 3.81023Z"
                                                fill="var(--container-color)"
                                            ></path>
                                            <path
                                                d="M13.25 13.7502H7.25C6.84 13.7502 6.5 13.4102 6.5 13.0002C6.5 12.5902 6.84 12.2502 7.25 12.2502H13.25C13.66 12.2502 14 12.5902 14 13.0002C14 13.4102 13.66 13.7502 13.25 13.7502Z"
                                                fill="var(--container-color)"
                                            ></path>
                                            <path
                                                d="M11.25 17.7502H7.25C6.84 17.7502 6.5 17.4102 6.5 17.0002C6.5 16.5902 6.84 16.2502 7.25 16.2502H11.25C11.66 16.2502 12 16.5902 12 17.0002C12 17.4102 11.66 17.7502 11.25 17.7502Z"
                                                fill="var(--container-color)"
                                            ></path>
                                        </svg>
                                    </a>
                                </div>
                            </div>

                            <div>
                                <span className="education__rounder"></span>
                                <span className="education__line"></span>
                            </div>
                        </div>

                        <div className="education__data">
                            <div></div>
                            <div>
                                <span className="education__rounder"></span>
                                <span className="education__line"></span>
                            </div>

                            <div className="education__subdata">
                                <div>
                                    <h3 className="education__title">HSC - PCM</h3>
                                </div>

                                <span className="education__button" onClick={() => toggleTab(2)}>
                                    View More
                                    <i className="uil uil-arrow-right education__button-icon"></i>
                                </span>
                            </div>

                            <div className={toggleState === 2 ? "education__modal active-modal" : "education__modal"}>
                                <div className="education__modal-content">
                                    <i className="uil uil-times education__modal-close" onClick={() => toggleTab(0)}></i>

                                    <h3 className="education__modal-title"> Higher Secondry School Certificate (HSC) </h3>

                                    <div className="education__modal-description">
                                        <div className="education__subtitle">
                                            <i class="uil uil-check-circle"></i>
                                            Shri J M Chaudhari Sarvajanik Vidyalaya</div>
                                        <div className="education__subtitle">
                                            <i class="uil uil-check-circle"></i>
                                            Mehsana, Gujarat </div>
                                        <div class="education__grade">
                                            <i class="uil uil-check-circle"></i>
                                            Percentage: 76</div>
                                        <div className="education__calender">
                                            <i class="uil uil-calendar-alt"></i>
                                            2018 - 2020
                                        </div>
                                    </div>

                                    <a download="" href={ResultHSC} className="download button button--flex ">
                                        Download

                                        <svg
                                            className="button__icon"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                d="M15.25 22.7502H9.25C3.82 22.7502 1.5 20.4302 1.5 15.0002V9.00024C1.5 3.57024 3.82 1.25024 9.25 1.25024H14.25C14.66 1.25024 15 1.59024 15 2.00024C15 2.41024 14.66 2.75024 14.25 2.75024H9.25C4.64 2.75024 3 4.39024 3 9.00024V15.0002C3 19.6102 4.64 21.2502 9.25 21.2502H15.25C19.86 21.2502 21.5 19.6102 21.5 15.0002V10.0002C21.5 9.59024 21.84 9.25024 22.25 9.25024C22.66 9.25024 23 9.59024 23 10.0002V15.0002C23 20.4302 20.68 22.7502 15.25 22.7502Z"
                                                fill="var(--container-color)"
                                            ></path>
                                            <path
                                                d="M22.25 10.7502H18.25C14.83 10.7502 13.5 9.42023 13.5 6.00023V2.00023C13.5 1.70023 13.68 1.42023 13.96 1.31023C14.24 1.19023 14.56 1.26023 14.78 1.47023L22.78 9.47023C22.99 9.68023 23.06 10.0102 22.94 10.2902C22.82 10.5702 22.55 10.7502 22.25 10.7502ZM15 3.81023V6.00023C15 8.58023 15.67 9.25023 18.25 9.25023H20.44L15 3.81023Z"
                                                fill="var(--container-color)"
                                            ></path>
                                            <path
                                                d="M13.25 13.7502H7.25C6.84 13.7502 6.5 13.4102 6.5 13.0002C6.5 12.5902 6.84 12.2502 7.25 12.2502H13.25C13.66 12.2502 14 12.5902 14 13.0002C14 13.4102 13.66 13.7502 13.25 13.7502Z"
                                                fill="var(--container-color)"
                                            ></path>
                                            <path
                                                d="M11.25 17.7502H7.25C6.84 17.7502 6.5 17.4102 6.5 17.0002C6.5 16.5902 6.84 16.2502 7.25 16.2502H11.25C11.66 16.2502 12 16.5902 12 17.0002C12 17.4102 11.66 17.7502 11.25 17.7502Z"
                                                fill="var(--container-color)"
                                            ></path>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="education__data">

                            <div className="education__subdata">
                                <div>
                                    <h3 className="education__title education__title-flex">SSC</h3>
                                </div>

                                <span style={{ marginBottom: "0.5rem" }} className="education__button education__button-flex" onClick={() => toggleTab(3)}>
                                    View More
                                    <i className="uil uil-arrow-right education__button-icon"></i>
                                </span>
                            </div>

                            <div className={toggleState === 3 ? "education__modal active-modal" : "education__modal"}>
                                <div className="education__modal-content">
                                    <i className="uil uil-times education__modal-close" onClick={() => toggleTab(0)}></i>

                                    <h3 className="education__modal-title"> Secondary School Certificate (SSC)</h3>

                                    <div className="education__modal-description">
                                        <div className="education__subtitle">
                                            <i class="uil uil-check-circle"></i>
                                            Saraswati Vidhya Vihar</div>
                                        <div className="education__subtitle">
                                            <i class="uil uil-check-circle"></i>
                                            Mehsana, Gujarat </div>
                                        <div class="education__grade">
                                            <i class="uil uil-check-circle"></i>
                                            Percentage: 82</div>
                                        <div className="education__calender">
                                            <i class="uil uil-calendar-alt"></i>
                                            2018
                                        </div>
                                    </div>

                                    <a download="" href={ResultSSC} className="download button button--flex">
                                        Download

                                        <svg
                                            className="button__icon"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                d="M15.25 22.7502H9.25C3.82 22.7502 1.5 20.4302 1.5 15.0002V9.00024C1.5 3.57024 3.82 1.25024 9.25 1.25024H14.25C14.66 1.25024 15 1.59024 15 2.00024C15 2.41024 14.66 2.75024 14.25 2.75024H9.25C4.64 2.75024 3 4.39024 3 9.00024V15.0002C3 19.6102 4.64 21.2502 9.25 21.2502H15.25C19.86 21.2502 21.5 19.6102 21.5 15.0002V10.0002C21.5 9.59024 21.84 9.25024 22.25 9.25024C22.66 9.25024 23 9.59024 23 10.0002V15.0002C23 20.4302 20.68 22.7502 15.25 22.7502Z"
                                                fill="var(--container-color)"
                                            ></path>
                                            <path
                                                d="M22.25 10.7502H18.25C14.83 10.7502 13.5 9.42023 13.5 6.00023V2.00023C13.5 1.70023 13.68 1.42023 13.96 1.31023C14.24 1.19023 14.56 1.26023 14.78 1.47023L22.78 9.47023C22.99 9.68023 23.06 10.0102 22.94 10.2902C22.82 10.5702 22.55 10.7502 22.25 10.7502ZM15 3.81023V6.00023C15 8.58023 15.67 9.25023 18.25 9.25023H20.44L15 3.81023Z"
                                                fill="var(--container-color)"
                                            ></path>
                                            <path
                                                d="M13.25 13.7502H7.25C6.84 13.7502 6.5 13.4102 6.5 13.0002C6.5 12.5902 6.84 12.2502 7.25 12.2502H13.25C13.66 12.2502 14 12.5902 14 13.0002C14 13.4102 13.66 13.7502 13.25 13.7502Z"
                                                fill="var(--container-color)"
                                            ></path>
                                            <path
                                                d="M11.25 17.7502H7.25C6.84 17.7502 6.5 17.4102 6.5 17.0002C6.5 16.5902 6.84 16.2502 7.25 16.2502H11.25C11.66 16.2502 12 16.5902 12 17.0002C12 17.4102 11.66 17.7502 11.25 17.7502Z"
                                                fill="var(--container-color)"
                                            ></path>
                                        </svg>
                                    </a>
                                </div>
                            </div>

                            <div>
                                <span className="education__rounder"></span>
                                <span className="education__line"></span>
                            </div>
                        </div>










                        {/* <div className="education__data">
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <h3 className="education__title education-flex">B.Tech - IT</h3>
                                <span style={{ marginBottom: "0px" }} className="education__subtitle education-flex"> Chandubhai S Patel Institute of Technology</span>
                                <span className="education__subtitle education-flex"> Changa, Anand, Gujarat </span>
                                <div className="education__grade education-flex">CGPA: 8.87</div>
                                <div className="education__calender education-flex">
                                    <i className="uil uil-calender-alt"></i>
                                    2020 - Present
                                </div>
                                <br />
                            </div>

                            <div>
                                <span className="education__rounder"></span>
                                <span className="education__line"></span>
                            </div>
                        </div>

                        <div className="education__data">
                            <div></div>
                            <div>
                                <span className="education__rounder"></span>
                                <span className="education__line"></span>
                            </div>
                            <div>
                                <h3 className="education__title">HSC - PCM</h3>
                                <span style={{ marginBottom: "0px" }} className="education__subtitle">Shri J M Chaudhari Sarvajanik Vidyalaya</span>
                                <span className="education__subtitle"> Mehsana, Gujarat </span>
                                <div className="education__grade">Percent: 76%</div>
                                <div className="education__calender">
                                    <i className="uil uil-calender-alt"></i>
                                    2018 - 2020
                                </div>
                                <br />
                            </div>
                        </div>

                        <div className="education__data">
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <h3 className="education__title education-flex">SSC</h3>
                                <span style={{ marginBottom: "0px" }} className="education__subtitle education-flex">Saraswati Vidhya Vihar</span>
                                <span className="education__subtitle education-flex"> Mehsana, Gujarat </span>
                                <div className="education__grade education-flex" >Percent: 82%</div>
                                <div className="education__calender education-flex">
                                    <i className="uil uil-calender-alt"></i>
                                    2017
                                </div>
                            </div>

                            <div>
                                <span className="education__rounder"></span>
                                <span className="education__line"></span>
                            </div>
                        </div> */}






                    </div>
                </div>
            </div>
        </div>
    )
}

export default Education
